<script>

import { createEventDispatcher } from 'svelte';

const dispatch = createEventDispatcher();

function updateRoute(newRoute) {
		dispatch('message', {
			route: newRoute
		});
}

</script>


<br>
<hr>

<p class="centered">
  <span class="pointer" on:click={() => updateRoute('/')}>
    HOME
  </span>
  |
  <span class="pointer" on:click={() => updateRoute('/stats')}>
    STATS
  </span>
  |
  <span class="pointer" on:click={() => updateRoute('/about')}>
    ABOUT
  </span>
</p>


<style>

  .centered {
    text-align: center;
    margin-bottom: 0px;
  }

  hr {
    border-top: 1px solid #DDD;
  }

  .pointer {
    cursor: pointer;
  }

</style>